import { cleanEntity } from 'shared/lib/util/entity-utils';
import { cmsHttp } from 'shared/api/mfe-axios';
import { buildSpringPageParams } from 'shared/api/list-query-params';
import { REQUEST, SUCCESS, FAILURE } from 'shared/lib/reducers/action-type.util';
import { defaultValue } from '@entities/card-schema/model';
export const ACTION_TYPES = {
    FETCH_CARD_SCHEMAS_LIST: 'cardSchema/FETCH_CARD_SCHEMAS_LIST',
    CREATE_CARD_SCHEMA: 'cardSchema/CREATE_CARD_SCHEMA',
    UPDATE_CARD_SCHEMA: 'cardSchema/UPDATE_CARD_SCHEMA',
    DELETE_CARD_SCHEMA: 'cardSchema/DELETE_CARD_SCHEMA',
    RESET: 'cardSchema/RESET',
};
const listApiUrl = 'api/card-schemas';
const apiUrl = 'api/card-schemas';
const initialState = {
    loading: false,
    errorMessage: null,
    entities: [],
    entity: defaultValue,
    updating: false,
    updateSuccess: false,
    totalItems: 0,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST(ACTION_TYPES.FETCH_CARD_SCHEMAS_LIST):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                loading: true,
            };
        case REQUEST(ACTION_TYPES.CREATE_CARD_SCHEMA):
        case REQUEST(ACTION_TYPES.UPDATE_CARD_SCHEMA):
        case REQUEST(ACTION_TYPES.DELETE_CARD_SCHEMA):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                updating: true,
            };
        case FAILURE(ACTION_TYPES.FETCH_CARD_SCHEMAS_LIST):
        case FAILURE(ACTION_TYPES.CREATE_CARD_SCHEMA):
        case FAILURE(ACTION_TYPES.UPDATE_CARD_SCHEMA):
        case FAILURE(ACTION_TYPES.DELETE_CARD_SCHEMA):
            return {
                ...state,
                loading: false,
                updating: false,
                updateSuccess: false,
                errorMessage: action.payload,
            };
        case SUCCESS(ACTION_TYPES.FETCH_CARD_SCHEMAS_LIST): {
            const body = action.payload.data;
            const list = Array.isArray(body) ? body : body?.content ?? [];
            const countHeader = action.payload.headers?.['x-total-count'];
            const total = countHeader != null && countHeader !== '' ? parseInt(countHeader, 10) : list.length;
            return {
                ...state,
                loading: false,
                entities: list,
                totalItems: Number.isNaN(total) ? list.length : total,
            };
        }
        case SUCCESS(ACTION_TYPES.CREATE_CARD_SCHEMA):
        case SUCCESS(ACTION_TYPES.UPDATE_CARD_SCHEMA):
            return {
                ...state,
                updating: false,
                updateSuccess: true,
                entity: action.payload.data,
                loading: false,
            };
        case SUCCESS(ACTION_TYPES.DELETE_CARD_SCHEMA):
            return {
                ...state,
                updating: false,
                updateSuccess: true,
                entity: defaultValue,
                loading: false,
            };
        case ACTION_TYPES.RESET:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};
export const getEntities = (params) => ({
    type: ACTION_TYPES.FETCH_CARD_SCHEMAS_LIST,
    payload: cmsHttp().get(listApiUrl, params === undefined ? undefined : { params: buildSpringPageParams(params) }),
});
const buildCreatePayload = (entity) => {
    const { schemaCode, schemaName, description, bin, cardRangeStart, cardRangeEnd, cardLength, cardNetworkCode, issuerId, isActive } = entity;
    return cleanEntity({
        schemaCode,
        schemaName,
        description,
        bin,
        cardRangeStart,
        cardRangeEnd,
        cardLength,
        cardNetworkCode,
        issuerId,
        isActive,
    });
};
export const createEntity = (entity) => async (dispatch) => dispatch({
    type: ACTION_TYPES.CREATE_CARD_SCHEMA,
    payload: cmsHttp().post(apiUrl, buildCreatePayload(entity)),
});
export const updateEntity = (entity) => async (dispatch) => {
    if (entity.id == null) {
        return undefined;
    }
    return dispatch({
        type: ACTION_TYPES.UPDATE_CARD_SCHEMA,
        payload: cmsHttp().put(`${apiUrl}/${entity.id}`, cleanEntity(entity)),
    });
};
export const deleteEntity = (id) => async (dispatch) => dispatch({
    type: ACTION_TYPES.DELETE_CARD_SCHEMA,
    payload: cmsHttp().delete(`${apiUrl}/${id}`),
});
export const reset = () => ({
    type: ACTION_TYPES.RESET,
});
